// Expand product description

jQuery(".m-product__expand button").bind("click",function(){
    productDescription = jQuery(this).closest(".m-product__description");
    jQuery(productDescription).removeClass("m-product__description--collapsed");
    jQuery(productDescription).addClass("js-m-product__description--expanded");
});

// Accordions

jQuery(".m-product__accordion-toggle").each(function() {

    jQuery(this).bind("click",function(e){
        accordion = jQuery(this).attr("href");
        jQuery(accordion).toggleClass("js-m-product__accordion--isactive");
        e.preventDefault();
    });

});

jQuery(".m-product__intro-rating-count a").bind("click",function(){
    accordion = jQuery(this).attr("href");
    jQuery(accordion).addClass("js-m-product__accordion--isactive");
});

jQuery(".m-product__attributes-vendor-more a").bind("click",function(e){
    options = jQuery(this).attr("href");
    jQuery(options).toggleClass("js-m-product__attributes-more-vendor--isactive");
    e.preventDefault();
});